import { __awaiter } from "tslib";
import moment from 'moment';
import { alas, status } from '@/alas';
import { showError } from '@/store';
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let t = m => context.root.$t(m);
        let route = context.root.$route;
        let router = context.root.$router;
        // ================
        //
        // refs
        //
        let farm = ref(status.fetch('farm'));
        let config = ref(status.fetch('config'));
        // ================
        //
        // state
        //
        let state = reactive({
            date: null,
            start: moment().format('YYYY-MM'),
            validate: false,
            calendar: alas.make('farm', 'calendar'),
            calendarDay: alas.make('farm', 'calendarDay'),
            calendarEvent: alas.make('farm', 'calendarEvent'),
            dateDialog: false,
            eventDialog: false
        });
        // ================
        //
        // computed
        //
        let startValue = computed(() => moment(state.start).format('YYYY-MM-DD'));
        let events = computed(() => {
            if (state.calendar == null) {
                return [];
            }
            let output = [];
            state.calendar.days.forEach(day => {
                day.events.forEach(event => {
                    let type = config.value.calendarTypes.find(type => type.value === event.type);
                    output.push({
                        name: event.name,
                        start: event.$parent.date,
                        color: type ? type.color : 'primary',
                        model: event
                    });
                });
            });
            return output;
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            setCalendar(state.start);
        });
        // ================
        //
        // methods
        //
        let next = () => {
            state.start = moment(state.start).add(1, 'month').format('YYYY-MM');
            setCalendar(state.start);
        };
        let prev = () => {
            state.start = moment(state.start).subtract(1, 'month').format('YYYY-MM');
            setCalendar(state.start);
        };
        let setCalendar = (yyyymm) => {
            state.calendar = alas.make('farm', 'calendar');
            state.calendar.$o.fetch.start({
                farmId: route.params.id,
                yyyymm
            });
        };
        let toTop = () => {
            window.scrollTo(0, 0);
        };
        let close = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield state.calendarDay.$o.update.start();
            }
            catch (error) {
                showError(error);
            }
            state.dateDialog = false;
        });
        let showEvent = ({ event }) => {
            state.calendarEvent = event.model;
            state.eventDialog = true;
        };
        let showDate = ({ month, date }) => {
            let r = config.value.calendarWriteFutureRefuseDays;
            let start = new Date(state.start);
            let select = moment(date).valueOf();
            if (select < moment().subtract(1, 'd').valueOf()) {
                return showError(t('你不能在過去建立事件'));
            }
            if (start.getMonth() + 1 !== month) {
                return showError(t('未在選取月份內'));
            }
            if (select > moment().add(r, 'd').valueOf()) {
                return showError(t('不能規劃太過於未來的事件'));
            }
            let id = route.params.id;
            let day = state.calendar.days.fetch(date);
            if (day == null) {
                day = alas.make('farm', 'calendarDay').$init({
                    date: date,
                    farmId: id
                });
                state.calendar.days.write(day);
            }
            state.dateDialog = true;
            state.calendarDay = day;
        };
        let addEvent = () => {
            state.calendarDay.events.write({
                name: ''
            });
        };
        let getEventColor = (event) => {
            return event.color;
        };
        let removeEvent = (event) => {
            state.calendarDay.events.removeByItem(event);
        };
        // ================
        //
        // done
        //
        return {
            farm,
            config,
            state,
            startValue,
            events,
            next,
            prev,
            setCalendar,
            toTop,
            close,
            showEvent,
            showDate,
            addEvent,
            getEventColor,
            removeEvent
        };
    }
});
